import { Button, Space, Text } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as NoBookkeepersIllustration } from '../../../../../../../../assets/images/organization-users-settings/no-bookkeepers.svg'
import { useEmberTransitionTo } from '../../../../../../../../hooks/routing/useEmberTransitionTo'
import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { getImageClassName } from '../../../../../../../../utils/getClassName'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import * as Styled from './styles'

export const BookkeepersEmptyView = (): ReactElement => {
  const { t } = useTranslation()
  const { transitionTo } = useEmberTransitionTo()

  const findAccountantRoute = reactRoute.organization.findAccountant.getMainRoute()
  const { url: findAccountantUrl } = useOrganizationViewUrl(findAccountantRoute)

  const handleFindBookkeeperClick = useCallback(() => {
    if (findAccountantUrl) {
      transitionTo(findAccountantUrl)
    }
  }, [transitionTo, findAccountantUrl])

  return (
    <Styled.BookkeepersEmptyView>
      <NoBookkeepersIllustration className={getImageClassName()} />
      <Space size="s12" />
      <Text colorVariant="secondary">{t('settings.organization.users.bookkeepers_section.empty_content')}</Text>
      <Space size="s16" />
      <Button onClick={handleFindBookkeeperClick}>
        {t('settings.organization.users.bookkeepers_section.find_bookkeeper')}
      </Button>
    </Styled.BookkeepersEmptyView>
  )
}
